import { Expose, Type } from 'class-transformer';

import { SnRecording, SnStreamSources } from '@lib/api/entities';

export class SnLiveIncident extends SnRecording {
  @Expose() @Type(() => SnStreamSources) public liveUrls: SnStreamSources;
  public isPlayed = false;

  constructor(data: any = {}) {
    super(data);
  }
}
